import { z } from 'zod'

import { useFormWithZod } from '@/hooks/useFormWithZod'

const schema = () =>
  z.object({
    page: z
      .object({
        background: z.string().optional(),
        form: z.string().optional(),
      })
      .optional(),
    font: z
      .object({
        text: z.string().optional(),
      })
      .optional(),
    button: z
      .object({
        text: z.string().optional(),
        background: z.string().optional(),
      })
      .optional(),
  })

export type FormAppearanceModel = z.infer<ReturnType<typeof schema>>

export const useFormAppearance = () => {
  const formAppearanceSchema = schema()
  const { form, rule } = useFormWithZod(formAppearanceSchema)
  return { form, rule, schema: formAppearanceSchema }
}
